define([
    'basemodel',
    'moment-wrapper'
], (BaseModel, moment) => BaseModel.extend({

    initialize () {
        BaseModel.prototype.initialize.apply(this, arguments);

        this.listenTo(this, 'change:start_date change:end_date', this.setDuration);
        this.setDuration();
    },

    setDuration () {
        let startDate = this.get('start_date');
        let endDate = this.get('end_date');
        let duration; let daysPass; let daysLeft;

        if (startDate && endDate) {
            const today = moment();
            startDate = moment(startDate);
            endDate = moment(endDate);

            duration = endDate.diff(startDate, 'days') + 1;

            if (today.isBefore(startDate)) {
                daysPass = 0;
            } else if (today.isAfter(endDate)) {
                daysPass = duration;
            } else {
                daysPass = today.diff(startDate, 'days') + 1;
            }
            daysLeft = duration - daysPass;
        } else {
            duration = daysPass = daysLeft = null;
        }

        this.set({duration, days_pass: daysPass, days_left: daysLeft});
    }
}));
